import { DatePipe } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ManageCompanyAccessComponent } from 'src/app/Company/manage-company-access/manage-company-access.component';
import { ALERT_TYPE, ERROR_MESSAGES } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company, ICompanyGroup } from 'src/model/company.model';
import { CompanyService } from 'src/services/company.service';

@Component({
    selector: 'app-add-company',
    templateUrl: './add-company.component.html',
    styleUrls: ['./add-company.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class AddCompanyComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private companyService = inject(CompanyService);

  company: Company = new Company();

  initialCashBookBalance: number;
  initialCashBookDate: Date;

  companyGroupList: ICompanyGroup[] = [];
  selectedGroupId: number;

  disabledSubmit = false;

  requireConsentForm = false;

  isCopyDetailsFromMainBranch = false;
  allCompanyList: Company[] = [];
  selectedSourceCompanyID: number;

  businessId: number;
  branchId: number;

  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    this.getAllGroups();
    this.loadAllCompanyList();
    // this.getAllBusiness();
    // this.getAllLicense();
  }

  validateFields() {
    const errors: string[] = [];
    if (this.company.CompanyCode == null || this.company.CompanyCode === '')
      errors.push(ERROR_MESSAGES.EMPTY_FIELD('Company Code'));
    if (this.company.Group == null)
      errors.push(ERROR_MESSAGES.EMPTY_FIELD('Company Group'));
    if (this.businessId == null || this.branchId == null)
      errors.push(ERROR_MESSAGES.EMPTY_SELECTION('License'));
    if (this.initialCashBookBalance == null || isNaN(+this.initialCashBookBalance))
      errors.push(ERROR_MESSAGES.INVALID_FIELD('Initial Cash Book Balance'));
    if (this.initialCashBookDate == null)
      errors.push(ERROR_MESSAGES.EMPTY_FIELD('Initial Cash Book Date'));
    if (this.company.DateOperating == null)
      errors.push(ERROR_MESSAGES.EMPTY_FIELD('Date Operating'));
    return errors;
  }

  async getAllGroups() {
    this.companyGroupList = await this.companyService.getAllCompanyGroups();
  }

  async loadAllCompanyList() {
    this.allCompanyList = await this.companyService.getAllCompanies();
    this.allCompanyList.sort((a, b) => (a.CompanyCode < b.CompanyCode ? -1 : 1));
  }

  submit() {
    const errors = this.validateFields();
    errors.length > 0 ? this.sharedService.openAlert(errors.map(e => `- ${e}`).join('\n'), ALERT_TYPE.DANGER) : this.addCompany();
  }

  async addCompany() {
    this.disabledSubmit = true;
    // in order to get the correct result, end date need to add 1 day and minus 1 millisecond
    // 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
    const reduceASecDate = (this.initialCashBookDate !== undefined) ? new Date (this.initialCashBookDate?.getTime() - 1) : undefined;
    this.company.BranchId = this.branchId;
    const comp: Company = await this.companyService.addCompany(this.company, { initialCashBookBalance: this.initialCashBookBalance, initialCashBookDate: reduceASecDate });
    this.passEntry.emit(comp);

    this.reset();
    this.sharedService.openAlert("Successfully added company!", ALERT_TYPE.SUCCESS);
    this.openCompanyAccessModal(comp.ID, comp.CompanyCode);
  }

  openCompanyAccessModal(companyID: number, companyCode: string) {
    const modalRef = this.sharedService.openModal(ManageCompanyAccessComponent, "largeModal");
    modalRef.componentInstance.selectedCompany = companyID;
    modalRef.componentInstance.selectedCompanyCode = companyCode;
  }

  reset() {
    this.activeModal.close();
  }
}
